import { schema } from 'normalizr';

export const substanceInformationSchema = new schema.Entity(
  'substanceInformations',
  {},
  { idAttribute: 'SubstanceInformationId' },
);

export const substanceInformationListSchema = [substanceInformationSchema];
